import { connect } from 'react-redux'
import VolunteerBulkRegistrationScene from '../../scenes/volunteer-bulk-registration'
import { setOpenLogin } from '../reducers/EventDetail'

function mapDispatchToProps(dispatch: any) {
  return {
    setOpenLogin: (isOpenLogin: boolean) => dispatch(setOpenLogin(isOpenLogin)),
  }
}

export default connect(null, mapDispatchToProps)(VolunteerBulkRegistrationScene)
